'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_SPACING = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = FieldRow;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _style = require('../../utils/style');

var _layout = require('../layout');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_SPACING = exports.DEFAULT_SPACING = 20;

/**
 * Render fields (children) in a row
 */

function FieldRow(props) {
  var children = props.children,
      _props$gutter = props.gutter,
      gutter = _props$gutter === undefined ? DEFAULT_SPACING : _props$gutter,
      className = props.className,
      otherProps = (0, _objectWithoutProperties3.default)(props, ['children', 'gutter', 'className']);


  return React.createElement(
    _layout.Box,
    (0, _extends3.default)({
      className: className,
      flexDirection: 'row',
      alignItems: 'top',
      marginLeft: -gutter,
      marginTop: DEFAULT_SPACING
    }, (0, _style.pickStyles)(otherProps)),
    React.Children.map(children, function (child) {
      return child ? React.cloneElement(child, {
        flex: child.props.flex || 1,
        marginLeft: 0,
        paddingLeft: gutter
      }) : child;
    })
  );
}


//////////////////
// WEBPACK FOOTER
// ./~/@kalo/ui/lib/components/field-row/field-row.js
// module id = 315
// module chunks = 114276838955818